import { put } from 'redux-saga/effects';

// actions
import { push } from 'react-router-redux';

export default function* (urlPath, step, errors, validationParams) {
  const errorFields = Object.keys(errors);
  const stepIndex   = step - 1;

  let hasError = false;

  for (let i = 0; i < validationParams.length; i++) {
    const stepParams = validationParams[i];

    for (let j = 0; j < errorFields.length; j++) {
      const errorField = errorFields[j];

      if (stepParams.indexOf(errorField) > -1) {
        hasError = true;

        if (i !== stepIndex) yield put(push(`${urlPath}?step=${i + 1}`));

        break;
      }
    }

    if (hasError) break;
  }
}



// WEBPACK FOOTER //
// ./app/lib/handleWizardNavigationOnError.js